import { rem, type MantineTheme } from "@mantine/core";

export function getAccordionTileStyles(theme: MantineTheme) {
    return {
        item: {
            backgroundColor: theme.white,
            border: "none",
            boxShadow: theme.shadows.sm,
        },
        control: {
            "&[data-active], &:hover": {
                backgroundColor: theme.colors[theme.primaryColor][0],
            },
        },
        panel: {
            "&[data-active], [data-active] &": {
                borderTop: `3px solid ${theme.colors[theme.primaryColor][5]}`,
            },
        },
    };
}

export function getAccordionTileIconStyles(theme: MantineTheme) {
    return {
        flexShrink: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "50%",
        backgroundColor: theme.colors[theme.primaryColor][5],
        width: 32,
        height: 32,
        fontSize: rem(16),
        [`@media (min-width: ${theme.breakpoints.sm})`]: {
            width: 40,
            height: 40,
            fontSize: rem(24),
        },
    };
}